<mat-form-field
  class="munily-filter-select-field"
  appearance="outline"
  [floatLabel]="floatLabel"
  [ngClass]="formFieldClasses"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>

  <mat-icon
    *ngIf="iconLeading"
    matPrefix
    class="munily-ff-icon material-symbols-rounded"
    aria-hidden="true"
  >
    {{ iconLeading }}
  </mat-icon>

  <mat-select
    [formControl]="resolvedControl"
    [multiple]="multiple"
    [panelClass]="panelClass"
    [disableOptionCentering]="disableOptionCentering"
    [compareWith]="resolvedCompareWith"
    [placeholder]="placeholder"
    (selectionChange)="onSelectionChange($event)"
    (openedChange)="onOpenedChange($event)"
  >
    <mat-option
      *ngIf="searchable"
      disabled
      class="munily-filter-select-search-option"
    >
      <input
        #optionSearchInput
        type="text"
        class="munily-filter-select-search-input"
        [formControl]="optionFilterControl"
        [placeholder]="searchPlaceholder"
        (keydown)="$event.stopPropagation()"
        (click)="$event.stopPropagation()"
      />
    </mat-option>
    <mat-option *ngFor="let opt of filteredOptions" [value]="opt.value">
      <ng-container [ngSwitch]="!!opt.labelKey">
        <span *ngSwitchCase="true">{{ opt.labelKey | translate }}</span>
        <span *ngSwitchDefault>{{ opt.label }}</span>
      </ng-container>
    </mat-option>
    <mat-option
      *ngIf="searchable && filteredOptions.length === 0"
      disabled
      class="munily-filter-select-empty-option"
    >
      {{ 'common.noResults' | translate }}
    </mat-option>
  </mat-select>

  <span
    *ngIf="showClearButton()"
    matSuffix
    class="munily-filter-select-clear"
    (mousedown)="onClearPointerDown($event)"
  >
    <common-icon-button
      variant="plain"
      icon="cancel"
      [iconFill]="true"
      [ariaLabel]="clearAriaLabel"
      [stopClickPropagation]="true"
      (output)="onClear()"
    ></common-icon-button>
  </span>

  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  <mat-error *ngIf="showError()">{{ resolvedErrorMessage }}</mat-error>
</mat-form-field>
